import clsx from 'clsx';
import React, { useState } from 'react';

const scrollToLogin = () => {
  const loginSection = document.querySelector('#login-section');
  if (loginSection) {
    loginSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const StickyHeader: React.FC = () => {
  const [selectedFlag, setSelectedFlag] = useState('/images/flag-philippines.png');
  const [logoHref, setLogoHref] = useState('https://cloudcfo.ph/');

  const handleFlagChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const flag = value === 'PH' ? '/images/flag-philippines.png' : '/images/flag-global.png';
    setSelectedFlag(flag);
    const href = value === 'PH' ? 'https://cloudcfo.ph/' : 'https://cloudcfo.co/?location=global';
    setLogoHref(href);
    window.location.href = href; // Redirect the page to the selected logo href
  };

  return (
    <header
      className={clsx(
        'tw-fixed',
        'tw-top-0',
        'tw-left-0',
        'tw-w-full',
        'tw-bg-white',
        'tw-shadow-md',
        'tw-z-50',
        'tw-flex',
        'tw-items-center',
        'tw-justify-between',
        'tw-px-6',
        'tw-py-4',
        'md:tw-px-32'
      )}
    >
      <div className="tw-flex tw-items-center">
        <a href={logoHref} target="_blank" rel="noopener noreferrer">
          <img
            src={'images/cloudcfo-logo-colored-icon-only.png'} // Mobile logo
            alt="CloudCFO Logo"
            className={clsx('tw-h-auto', 'tw-mr-2', 'md:tw-hidden')} // Hidden on medium and larger screens
            style={{ width: '50px', height: 'auto' }}
          />
          <img
            src={'images/cloudcfo-logo-colored-icon-beside-text.png'} // Desktop logo
            alt="CloudCFO Logo"
            className={clsx('tw-h-auto', 'tw-mr-2', 'tw-hidden', 'md:tw-block')} // Visible on medium and larger screens
            style={{ width: '200px', height: 'auto' }}
          />
        </a>
      </div>
      <div className="tw-flex tw-items-end tw-gap-4">
        <div className="tw-flex tw-items-center">
          <img src={selectedFlag} alt="Selected Flag" className="tw-w-8 tw-h-auto tw-mr-2" />
          <select
            onChange={handleFlagChange}
            className={clsx(
              'tw-px-2',
              'tw-py-1',
              'tw-text-xl',
              'tw-font-extrabold',
              'tw-outline-none',
              'tw-bg-white'
            )}
          >
            <option value="PH">
              <img src="/images/flag-philippines.png" alt="Philippines Flag" /> Philippines
            </option>
            <option value="US">
              <img src="/images/flag-global.png" alt="Global Flag" /> Global
            </option>
          </select>
        </div>
        <button
          onClick={scrollToLogin} // Added onClick handler to scroll to login section
          className={clsx(
            'tw-bg-[#188CD3]',
            'tw-text-white',
            'tw-rounded-full',
            'tw-px-4',
            'tw-py-2',
            'tw-text-xl',
            'tw-w-[80px]',
            'md:tw-w-[160px]',
            'hover:tw-bg-[#49a8f5]',
            'tw-shadow'
          )}
        >
          Log In
        </button>
      </div>
    </header>
  );
};

export default StickyHeader;
